import React, { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import DialogTitleWithCloseButton from "../DialogTitleWithCloseButton";
import { ROUTES } from "../../utils/Constant";
import { useDesignFetcher } from "../../utils/DesignsFetcherHooks";
import DesignService from "../../service/DesignService";
import styles from "./moveProjectModal.module.scss";
import { useSelector } from "react-redux";
import { generatePath, useNavigate } from "react-router-dom";

const MoveProjectModal = (props) => {
  const { open, onClickClose, designId, projectId } = props;
  const { t } = useTranslation();
  const [selectedProject, setSelectedProject] = React.useState(null);
  const projectsState = useSelector((state) => state.projects);

  const projects = useMemo(() => {
    return projectsState?.projects;
  }, [projectsState]);

  const teamsState = useSelector((state) => state.myTeams);
  const teams = useMemo(() => {
    return teamsState?.teams;
  }, [teamsState]);

  const navigate = useNavigate();
  const { fetchMyDesignsAndUpdateStore } = useDesignFetcher();
  const onAddToProject = useCallback(
    async (newProjectId) => {
      const moveProjObj = {
        designId: designId,
        newProjectId,
      };
      await DesignService.moveDesign(moveProjObj);

      await fetchMyDesignsAndUpdateStore(newProjectId);
      navigate(generatePath(ROUTES.DESIGNS, { projectId: newProjectId }));
    },
    [fetchMyDesignsAndUpdateStore, navigate, designId]
  );

  const teamProjects = useMemo(() => {
    const unFlattenedArray = teams.map((team) => {
      return {
        key: team.id,
        id: team.id,
        name: team.name,
        type: "team",
        projects: projects.filter((project) => project.team_id === team.id),
        teamUrl: generatePath(ROUTES.TEAM_PROJECTS, { teamId: team.id }),
        url: (projectId) => generatePath(ROUTES.DESIGNS, { projectId }),
      };
    });

    const flatObject = [];
    unFlattenedArray.forEach((team) => {
      team.projects.forEach((project) => {
        const individualProjectObj = {
          id: project.id,
          key: project.id,
          type: team.name,
          name: project.name,
          user_id: null,
          team_id: team.id,
        };
        return flatObject.push(individualProjectObj);
      });
    });
    return flatObject;
  }, [projects, teams]);
  return (
    <Dialog open={open} className={styles.modal} onClose={onClickClose}>
      <DialogTitleWithCloseButton
        id="customized-dialog-title"
        onClose={onClickClose}
      >
        {t("move.title")}
      </DialogTitleWithCloseButton>
      <DialogContent>
        <Autocomplete
          id="moveProjects"
          className={styles.autocompleteBox}
          forcePopupIcon={true}
          options={teamProjects}
          groupBy={(option) => option.type}
          getOptionLabel={(option) => option.name}
          filterOptions={(options, state) => {
            const value = state.inputValue.toUpperCase();
            return options.filter(
              (o) =>
                o.type.toUpperCase().includes(value) ||
                o.name.toUpperCase().includes(value)
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("move.move_to_team")}
              sx={{ margin: "0px", padding: "0px" }}
            />
          )}
          value={selectedProject}
          onChange={(event, newValue) => {
            setSelectedProject(newValue);
          }}
          getOptionDisabled={(option) => {
            // option.some((selected) => selected.id === projectId)
            if (option.id === projectId) {
              return true;
            } else return;
            //Disabled if already joined
          }}
          autoHighlight
          renderOption={(props, option) => {
            return (
              <li
                starticon={CheckIcon}
                {...props}
                key={option.name}
                variant={"li"}
              >
                <CheckIcon hidden={option.id !== projectId} />
                {option.name /*+ " (" + team.teamId + ")"*/}
              </li>
            );
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.button}
          align={"center"}
          onClick={() => onAddToProject(selectedProject.id)}
          disabled={selectedProject === null}
        >
          {t("move.action")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveProjectModal;
